import { FileText, Download, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MessageAttachmentProps {
  url: string;
  name: string;
  type: string;
  isFromAgent?: boolean;
}

export function MessageAttachment({ url, name, type, isFromAgent }: MessageAttachmentProps) {
  const isImage = type.startsWith("image/");
  const isPDF = type === "application/pdf";

  if (isImage) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className="block mt-2">
        <img
          src={url}
          alt={name}
          className="max-w-full max-h-48 rounded-lg object-cover cursor-pointer hover:opacity-90 transition-opacity"
        />
      </a>
    );
  }

  if (isPDF) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-2 mt-2 px-3 py-2 rounded-lg transition-colors ${
          isFromAgent
            ? "bg-primary-foreground/10 hover:bg-primary-foreground/20"
            : "bg-background/10 hover:bg-background/20"
        }`}
      >
        <FileText size={18} className={isFromAgent ? "text-primary-foreground" : "text-foreground"} />
        <span className={`text-sm truncate flex-1 ${isFromAgent ? "text-primary-foreground" : "text-foreground"}`}>
          {name}
        </span>
        <ExternalLink size={14} className={isFromAgent ? "text-primary-foreground/70" : "text-muted-foreground"} />
      </a>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-2 mt-2 px-3 py-2 rounded-lg transition-colors ${
        isFromAgent
          ? "bg-primary-foreground/10 hover:bg-primary-foreground/20"
          : "bg-background/10 hover:bg-background/20"
      }`}
    >
      <FileText size={18} />
      <span className="text-sm truncate flex-1">{name}</span>
      <Download size={14} />
    </a>
  );
}
